import styled from "styled-components"
import ContentBlock from "../../components/UI/ContentBlock"
import ContactForm from "../../components/ContactForm"

const ContactsScreen = () => {
	return (
		<>
			<ContentBlock top={0} bottom={0} background="#4c60eb">
				<MapWrapper/>
			</ContentBlock>
			<ContentBlock>
				<ContentWrapper>
					<ContactWrapper>
						<h2>Связаться с нами</h2>
						<Description>
							<p>Наш специалист по продукту и IT свяжется с вами и ответит на любые вопросы, включая
								вопросы интеграции и технических возможностей.
							</p>
							<p>Пишите в телеграм <a href="https://t.me/ats24ru" target="_blank">@ats24ru</a></p>
							<p>Звоните нам по телефону +7 (495) 212-91-55</p>
							<p>Мы работаем ежедневно с 09:00 до 20:00 по московскому времени.</p>
						</Description>
					</ContactWrapper>
					<FormWrapper>
						<h3>Напишите нам</h3>
						<ContactForm/>
					</FormWrapper>
				</ContentWrapper>
			</ContentBlock>
		</>

	)
}

export default ContactsScreen

const MapWrapper = styled.div`
    display: flex;
    justify-self: center;
    height: 25vw;
    max-height: 17.77rem;
    background: url('/assets/img/svg/map.svg') no-repeat top;
    background-size: 75% auto;
`
const ContentWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5.55rem;
    row-gap: 2.22rem;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }
`

const ContactWrapper = styled.div`
    display: flex;
    flex: .55;
    flex-direction: column;
`
const ContactUs = styled.div`
    font-size: 48px;
    font-weight: 700;
    line-height: 1;
`
const Description = styled.div`
    font-size: 24px;
`
const FormWrapper = styled.div`
    display: flex;
    flex: .45;
    flex-direction: column;
    gap: 24px;
`